export default "__VITE_ASSET__DX8VIpkA__"